
import { defineComponent, ref } from 'vue'
import { useStarTheme, useStarRouter } from '@/utils/useStarTheme'
import MessagePanel from '@/views/star/message.vue'

const __default__ = defineComponent({
  name: 'StarTabBar',
  components: { MessagePanel },
  props: {
    modelValue: { type: String, default: 'home' }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const { isLight, colors } = useStarTheme()
    const { starPush } = useStarRouter()
    const activeTab = ref(props.modelValue)
    const showMessage = ref(false)

    const tabs = [
      { key: 'home',   label: '首页',     path: '/star' },
      { key: 'quant',  label: '学习圈', path: '/star/quant' },
      { key: 'school', label: '投资学院',  path: '/allcourse' }
    ]

    const handleClick = (tab: { key: string; label: string; path: string }) => {
      activeTab.value = tab.key
      emit('update:modelValue', tab.key)
      const extraQuery: Record<string, string> = { from: 'star' }
      if (tab.key !== 'school') delete extraQuery.from
      starPush(tab.path, extraQuery)
    }

    return { tabs, activeTab, isLight, colors, handleClick, showMessage }
  }
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "330963a7": (_ctx.isLight ? 'transparent' : '#0F1012')
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__